import { type FC, type MouseEvent as ReactMouseEvent, useRef } from 'react';

import styles from './styles.css';

export interface IMarqueeProps {
  text: string;
  onMouseOver?: () => void;
  onMouseLeave?: () => void;
}

/* Компонент бегущей строки */
export const Marquee: FC<IMarqueeProps> = ({ text, onMouseOver, onMouseLeave }) => {
  const container = useRef<HTMLDivElement | null>(null);

  const mouseOverHandler = (event: ReactMouseEvent<HTMLDivElement>): void => {
    if (container.current) {
      const target = (event.target as HTMLSpanElement) || ({ offsetWidth: 0 } as HTMLSpanElement);
      const containerWith = container.current.offsetWidth;
      const childWith = target.offsetWidth;

      const diff = childWith - containerWith;

      if (diff > 0) {
        target.style.transition = `transform ${diff / 100}s linear`;
        target.style.transform = `translate(-${diff}px, 0)`;
      }

      onMouseOver?.();
    }
  };

  const mouseLeaveHandler = (event: ReactMouseEvent<HTMLDivElement>): void => {
    const target = event.target as HTMLSpanElement;

    if (target) {
      target.style.transform = '';
      target.style.transition = '';
    }

    onMouseLeave?.();
  };

  return (
    <div
      className={styles['container']}
      ref={container}
      onMouseLeave={mouseLeaveHandler}
      onMouseOver={mouseOverHandler}
    >
      <span className={styles['text']} data-testid="MarqueeText">
        {text}
      </span>
    </div>
  );
};
